import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  useTheme,
  useMediaQuery,
  Dialog,
  IconButton,
  Slide,
} from '@mui/material';
import {
  Close,
  ChevronLeft,
  ChevronRight,
  ZoomIn,
} from '@mui/icons-material';

import gallery1 from '../assets/images/gallary1.jpg';
import gallery2 from '../assets/images/gallary2.jpg';
import gallery3 from '../assets/images/gallary3.jpg';
import gallery4 from '../assets/images/gallary4.jpg';
import gallery5 from '../assets/images/gallary5.jpg';
import gallery6 from '../assets/images/gallary7.jpg';
import gallery7 from '../assets/images/gallary8.jpg';
import gallery8 from '../assets/images/gallary9.jpg';
import gallery9 from '../assets/images/gallary10.jpg';
import gallery10 from '../assets/images/gallary11.jpg';
import gallery11 from '../assets/images/gallary12.jpg';
import gallery12 from '../assets/images/gallary13.jpg';
import gallery13 from '../assets/images/gallary14.jpg';
// import gallery14 from '../assets/images/gallary8.jpg';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const galleryImages = [
    {
      id: 1,
      image: gallery1,
      // alt: 'Deluxe Room',
      // category: 'rooms',
      // title: 'Deluxe Room',
    },
    {
      id: 2,
      image: gallery2,
      // alt: 'Family Suite',
      // category: 'rooms',
      // title: 'Family Suite',
    },
    {
      id: 3,
      image: gallery3,
      // alt: 'Super Deluxe Room',
      // category: 'rooms',
      // title: 'Super Deluxe Room',
    },
    {
      id: 4,
      image: gallery4,
      // alt: 'Guhagar Beach',
      // category: 'beach',
      // title: 'Guhagar Beach',
    },
    {
      id: 5,
      image: gallery5,
      // alt: 'Beach View',
      // category: 'beach',
      // title: 'Beach View',
    },
    {
      id: 6,
      image: gallery6,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    {
      id: 7,
      image: gallery7,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    {
      id: 8,
      image: gallery8,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    {
      id: 9,
      image: gallery9,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    {
      id: 10,
      image: gallery10,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    {
      id: 11,
      image: gallery11,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    {
      id: 12,
      image: gallery12,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    {
      id: 13,
      image: gallery13,
      // alt: 'Restaurant',
      // category: 'restaurant',
      // title: 'Fine Dining Restaurant',
    },
    // {
    //   id: 14,
    //   image: gallery14,
    //   // alt: 'Restaurant',
    //   // category: 'restaurant',
    //   // title: 'Fine Dining Restaurant',
    // },
    // {
    //   id: 6,
    //   image: gallery6,
    //   // alt: 'Restaurant',
    //   // category: 'restaurant',
    //   // title: 'Fine Dining Restaurant',
    // },
    // {
    //   id: 7,
    //   image: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    //   alt: 'Swimming Pool',
    //   category: 'pool',
    //   title: 'Infinity Pool',
    // },
    // {
    //   id: 8,
    //   image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    //   alt: 'Spa',
    //   category: 'spa',
    //   title: 'Wellness Spa',
    // },
    // {
    //   id: 9,
    //   image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    //   alt: 'Resort Exterior',
    //   category: 'rooms',
    //   title: 'Resort Exterior',
    // },
  ];

  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImage(null);
  };

  const handlePrevious = () => {
    const newIndex = currentImageIndex === 0 ? galleryImages.length - 1 : currentImageIndex - 1;
    setCurrentImageIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const handleNext = () => {
    const newIndex = currentImageIndex === galleryImages.length - 1 ? 0 : currentImageIndex + 1;
    setCurrentImageIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleClose();
    } else if (event.key === 'ArrowLeft') {
      handlePrevious();
    } else if (event.key === 'ArrowRight') {
      handleNext();
    }
  };

  return (
    <Box sx={{ py: 8, backgroundColor: 'white' }} id="gallery">
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 2, fontWeight: 700, color: 'primary.main' }}
        >
          Cashew County
        </Typography>
        <Typography
          variant="h6"
          align="center"
          sx={{ mb: 6, color: 'text.secondary' }}
        >
          More photos of our Ploats
        </Typography>

        <Grid container spacing={2}>
          {galleryImages.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Card
                elevation={2}
                sx={{
                  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  cursor: 'pointer',
                  position: 'relative',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: theme.shadows[8],
                    '& .zoom-icon': {
                      opacity: 1,
                    },
                  },
                }}
                onClick={() => handleImageClick(item, index)}
              >
                <CardMedia
                  component="img"
                  height="250"
                  image={item.image}
                  alt={item.alt}
                  sx={{ objectFit: 'cover' }}
                />
                <Box
                  className="zoom-icon"
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: '50%',
                    width: 50,
                    height: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                  }}
                >
                  <ZoomIn sx={{ color: 'white', fontSize: 24 }} />
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Image Modal */}
      <Dialog
        fullScreen
        open={selectedImage !== null}
        onClose={handleClose}
        TransitionComponent={Transition}
        onKeyDown={handleKeyDown}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: 'rgba(0, 0, 0, 0.95)',
          },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 20,
              right: 20,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              zIndex: 10,
            }}
          >
            <Close />
          </IconButton>

          {/* Previous Button */}
          <IconButton
            onClick={handlePrevious}
            sx={{
              position: 'absolute',
              left: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              zIndex: 10,
            }}
          >
            <ChevronLeft />
          </IconButton>

          {/* Next Button */}
          <IconButton
            onClick={handleNext}
            sx={{
              position: 'absolute',
              right: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              zIndex: 10,
            }}
          >
            <ChevronRight />
          </IconButton>

          {/* Image */}
          {selectedImage && (
            <Box
              component="img"
              src={selectedImage.image}
              alt={selectedImage.alt}
              sx={{
                maxWidth: '90%',
                maxHeight: '90%',
                objectFit: 'contain',
                borderRadius: 2,
              }}
            />
          )}

          {/* Image Counter */}
          <Box
            sx={{
              position: 'absolute',
              bottom: 20,
              left: '50%',
              transform: 'translateX(-50%)',
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              padding: '8px 16px',
              borderRadius: 2,
              fontSize: '14px',
            }}
          >
            {currentImageIndex + 1} / {galleryImages.length}
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default Gallery;